import { useEffect } from "react";
import { useGetGruposQuery } from "services";
import { ESTUDIANTE } from "roles";

export const useStudentRole = (setFieldValue, groupsFieldName) => {
  const { data: grupos } = useGetGruposQuery(
    {
      filter_params: {
        query: "{name, url, id}",
      },
      shape: {
        id: "id",
        name: "name",
        url: "url",
      },
    },
    {
      refetchOnReconnect: true,
    }
  );

  const rol = grupos?.find((e) => e.name === ESTUDIANTE);

  useEffect(() => {
    if (rol !== undefined && setFieldValue && groupsFieldName) {
      setFieldValue(groupsFieldName, [rol?.id]);
    }
  }, [rol, setFieldValue, groupsFieldName]);

  return { rol };
};
